import footer from './footer'
import header from './header'
import banner from './banner'

import tabs from './tabs'
import list from './list'
import vid from './vid'

export default {footer,header,banner,list,tabs,vid}


// WEBPACK FOOTER //
// ./src/components/index.js